import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable()
export class ContextBarService {
    private readonly mainContents$: BehaviorSubject<TemplateRef<any>>;
    private readonly actionContents$: BehaviorSubject<TemplateRef<any>>;
    private readonly dynamicActionContents$: BehaviorSubject<{
        templateRef: TemplateRef<unknown>;
        data: any;
        cssClass: string;
    }>;

    constructor() {
        this.mainContents$ = new BehaviorSubject<TemplateRef<any>>(null);
        this.actionContents$ = new BehaviorSubject<TemplateRef<any>>(null);
        this.dynamicActionContents$ = new BehaviorSubject<{
            templateRef: TemplateRef<unknown>;
            data: any;
            cssClass: string;
        }>(null);
    }

    getMainContents() {
        return this.mainContents$;
    }

    setMainContents(templateRef: TemplateRef<any>) {
        this.mainContents$.next(templateRef);
    }

    getActionContents() {
        return this.actionContents$;
    }

    setActionContents(templateRef: TemplateRef<any>) {
        this.actionContents$.next(templateRef);
    }

    getDynamicActionsContents() {
        return this.dynamicActionContents$;
    }

    setDynamicActionsContents(
        templateRef: TemplateRef<any>,
        data: any,
        cssClass: string
    ) {
        this.dynamicActionContents$.next({ templateRef, data, cssClass });
    }
}
